module.exports = __webpack_public_path__ + "static/media/400008_02.8b101a3e.png";